<!--绑定手机-->
<template>
  <div class="binding" :style="'min-height:'+min_height+'px;'">
    <p class="status SourceHanSansCN" v-if="userDataBase.mobile!=''">已绑定手机号</p>
    <p class="status SourceHanSansCN" v-else>暂未绑定手机</p>
    <p class="tel SourceHanSansCN" v-if="userDataBase.mobile">{{ parseStringToStar(userDataBase.mobile) }}</p>
    <p class="tips">绑定手机号作为您的身份验证的重要方式，请谨慎操作！</p>
    <el-button type="danger" v-if="userDataBase.mobile" @click="updateTel(userDataBase.mobile)">更换手机号</el-button>
    <el-button type="danger" v-else @click="updateTel(userDataBase.mobile)">绑定手机号</el-button>
    <!--绑定手机-->
    <vxe-modal v-model="dialog_b" width="400" title="绑定手机" transfer>
      <template #default>
        <div class="bind">
          <p class="bigger-title SourceHanSansCN">已完成身份验证</p>
          <p class="default-text SourceHanSansCN">请输入新手机号</p>
          <vxe-input v-model="bindInfo.mobile" placeholder="请输入手机号" style="width: 100%;">
            <template #prefix>
              <i class="custom-prefix">+86</i>
            </template>
          </vxe-input>
          <p>
            <vxe-input v-model="bindInfo.code" placeholder="请输入六位验证码" style="width: 69.5%"/>
            <vxe-button content="获取验证码" @click="getNewIdentifyCode" v-if="flag2"/>
            <vxe-button :content="'剩余'+second2+'s'" v-if="!flag2" status="info" disabled style="width: 100px;"/>
          </p>
          <vxe-button status="danger" content="确定" style="width: 100%" @click="bindTelephone"/>
        </div>
      </template>
    </vxe-modal>
    <vxe-modal v-model="dialog_w" width="400" title="绑定手机" transfer>
      <template #default>
        <div class="bind">
          <p class="bigger-title SourceHanSansCN">请完成短信验证</p>
          <p class="default-text SourceHanSansCN">请输入 {{ showTelephone }} 短信验证码</p>
          <p>
            <vxe-input v-model="code" placeholder="请输入验证码" style="width: 69.5%"/>
            <vxe-button content="获取验证码" @click="getIdentifyCode" v-if="flag"/>
            <vxe-button :content="'剩余'+second+'s'" v-if="!flag" status="info" disabled style="width: 100px;"/>
          </p>
          <vxe-button status="danger" content="确定" style="width: 100%" @click="verification"/>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {verifyMoblie} from '@/api/loginApi'
import {sendsms,verifySms} from '@/api/currencyApi'

export default {
  name: "bindMobile",
  data() {
    return {
      userInfo: {
        is_bind: false,
        telephone: '',
      },
      dialog_b: false,
      dialog_w: false,
      bindInfo: {
        code: "",
        mobile: "",
        sign: "",
        uid: 0
      },
      flag: true,
      second: 300,
      flag2: true,
      second2: 300,
      code: '',
      timer: null, // 该变量是用来记录定时器的,防止点击的时候触发多个setInterval
      showTelephone: '',
      uid: 0,
      /*登录用户基本信息*/
      userDataBase: {},
      min_height: document.documentElement.clientHeight - 396,
    }
  },
  methods: {
    /*更换绑定手机号/绑定手机号*/
    updateTel(type) {
      if (type) {
        this.bindInfo.telephone = this.userDataBase.mobile;
        this.showTelephone = this.parseStringToStar(this.userDataBase.mobile);
        this.dialog_w = true;
      } else
        this.dialog_b = true;
    },
    /*当存在手机号获取旧手机号验证码*/
    getIdentifyCode() {
      let that = this;
      if (that.flag) {
        sendsms({
          mobile: that.userDataBase.mobile,
          name: "修改手机号",
          uid: that.userDataBase.cid,
          uuid: "帮企网"
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('验证码已发送');
            that.flag = false;
            let interval = window.setInterval(function () {
              that.setStorage(that.second);
              if (that.second-- <= 0) {
                that.second = 300;
                that.flag = true;
                window.clearInterval(interval);
              }
            }, 1000);
          }
        })
      }
    },
    /*获取新手机号的验证码*/
    getNewIdentifyCode() {
      let that = this;
      if (that.flag2) {
        verifyMoblie({moblie: that.bindInfo.mobile,uid:that.userDataBase.cid}).then(res=>{
          if (res.code==200){
            sendsms({mobile: that.bindInfo.mobile, name: "修改手机号", uid: that.userDataBase.cid, uuid: "帮企网"}).then(res=>{
              if (res.code==200){
                that.flag2 = false;
                let interval = window.setInterval(function() {
                  that.setStorage(that.second2);
                  if (that.second2-- <= 0) {
                    that.second2 = 300;
                    that.flag2 = true;
                    window.clearInterval(interval);
                  }
                }, 1000);
              }else{
                that.$message.error('短信发送失败！');
              }
            })
          }else{
            this.$message.error(res.esg);
          }
        })
      }
    },
    setStorage(parm) {
      localStorage.setItem("dalay", parm);
      localStorage.setItem("_time", new Date().getTime());
    },
    getStorage() {
      let localDelay = {};
      localDelay.delay = localStorage.getItem("dalay");
      localDelay.sec = localStorage.getItem("_time");
      return localDelay;
    },
    /*验证旧手机号*/
    verification() {
      let that = this;
      if (that.code != '') {
        verifySms({smscode: that.code,uuid: that.userDataBase.mobile,uid: that.userDataBase.cid}).then(res=>{
          if (res.code==200){
            that.bindInfo.sign=res.content;
            that.bindInfo.uid=that.uid;
            this.dialog_w=false;
            this.dialog_b=true;
          }else if (res.code==201){
            this.$message.error(res.msg);
          }
        })
      } else
        this.$message.warning('请填写验证码')
    },
    /*绑定手机*/
    bindTelephone() {
      let that = this;
      if (that.bindInfo.code != '') {
        /*bindANewPhoneNumber(that.bindInfo).then(res=>{
          if (res.code==200){
            this.$message.success(res.msg)
            this.dialog_b=false;
            this.$emit('getLoggedInUser');
          } else
            this.$message.error(res.msg);
        })*/
      } else
        this.$message.warning('请填写验证码')
    },
    /*手机号处理*/
    parseStringToStar(str) {
      let start = str.slice(0, 3)
      let end = str.slice(-4)
      return `${start}****${end}`
    },
  },
  beforeMount() {
    this.userDataBase = JSON.parse(sessionStorage.getItem('loginData'))
  }
}
</script>
<style scoped>
.binding >>> .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 20px;
}

.binding >>> .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.vxe-button.type--button.theme--danger:not(.is--disabled) {
  border-color: #FE273B;
  background-color: #FE273B;
}

.vxe-button.type--button.theme--danger:not(.is--disabled):hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.vxe-modal--wrapper .vxe-modal--content {
  padding: 0px;
}

.custom-prefix {
  color: #333333;
  font-style: normal;
  font-size: 14px;
  padding-left: 5px;
}
</style>
<style scoped lang="scss">
.binding {
  padding: 20px;
  background: #ffffff;

  .tips {
    font-size: 14px;
    color: #999999;
    margin-block-end: 30px;
  }

  .status {
    font-size: 14px;
    color: #333333;
  }

  .tel {
    color: #333333;
    font-size: 20px;
    margin-block-start: 0px;
  }
}

.bind {
  padding: 0px 0px 40px;

  .default-text {
    color: #333333;
    font-size: 14px;
  }

  .bigger-title {
    color: #333333;
    font-size: 18px;
    margin-block-start: 0px;
  }
}
</style>
<style>
.vxe-input.is--prefix .vxe-input--inner {
  padding-left: 2.5em !important;
}
</style>